import * as core from '../../../../../../../core'

import { query } from './degree-of-change-by-team.query'

export const RESOURCE = {
  payload: {
    alias: 'degree.of.change.by.team',
    description: 'Chart view of degree of change by team',
    name: 'Degree of Change by Team',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
